module.exports = __webpack_public_path__ + "img/novidades-cristal.574cf42b.png";